import React from "react";
import "./DocumentManagerUiComponent.css";
import { useDocumentsStateStore } from "../../store/documentsStateStore";
import DocumentHeaderComponent from "./DocumentHeaderComponent";

const DocumentManagerUiComponent = () => {
    const documents = useDocumentsStateStore(state => state.documents);
    const activeDocumentIndex = useDocumentsStateStore(state => state.activeDocumentIndex);
    const setActiveDocument = useDocumentsStateStore(state => state.setActiveDocument);

    if (documents.length === 0) {
        return null;
    }

    return (
        <div className="document-manager">
            {documents.map((contextDoc, index) => (
                <DocumentHeaderComponent
                    key={contextDoc.document.documentUuid}
                    contextDoc={contextDoc}
                    index={index}
                    isActive={index === activeDocumentIndex}
                    onClick={setActiveDocument}
                />
            ))}
        </div>
    );
};

export default DocumentManagerUiComponent;
